import { computed } from "vue";
import { useBaseStore } from "@store/base";
import { useRoute, useRouter } from "vue-router";

export default function () {
  const route = useRoute();
  const router = useRouter();
  const base = useBaseStore();

  const moduleName = route.meta.moduleName;
  const allModuleConfig = computed(() => {
    return base.moduleConfig;
  });
  const moduleConfig = computed(() => {
    return base.moduleConfig.find((item) => item.MODULE_ENNAME == moduleName);
  });
  const moduleTitle = computed(() => {
    try {
      return (
        JSON.parse(moduleConfig.value?.MODULE_NAME_MULTILINGUAL || "{}")?.[
          base.lang
        ] || ""
      );
    } catch (error) {
      return "";
    }
  });

  const getModuleById = (id) => {
    return base.moduleConfig.find((item) => item.ID == id);
  };

  const goFirstModulePage = async () => {
    while (!allModuleConfig.value[0]) {
      await new Promise((resolve) => setTimeout(resolve, 10));
    }
    router.push({
      path: allModuleConfig.value[0].MODULE_PATH,
    });
  };

  const waitUntilGetLangSucc = () => {
    return new Promise((resolve) => {
      if (base.lang) {
        resolve();
      } else {
        setTimeout(() => {
          waitUntilGetLangSucc().then(resolve);
        }, 10);
      }
    });
  };

  return {
    moduleName,
    moduleConfig,
    moduleTitle,
    getModuleById,
    goFirstModulePage,
    waitUntilGetLangSucc,
  };
}
